class PaginatioNews {
  constructor(el) {
    this.el = el;
    this.button = this.el.querySelector('.btn');

    this.bindListeners();
  }

  bindListeners() {
    this.button.addEventListener("click", this.handleClick.bind(this));
    this.count();
  }

  handleClick() {
    let hiddenItems = [];
    if(this.el.classList.contains('post-item__pagination--desktop')) {
      hiddenItems = document.querySelectorAll(".post-item--desktop.hide");
    } else if(this.el.classList.contains('post-item__pagination--mobile')){
      hiddenItems = document.querySelectorAll(".post-item--mobile.hide");
    }

    Array.from(hiddenItems).slice(0, 3).forEach(item => {
      item.classList.add("show");
      item.classList.remove("hide");
    });

    const remainingHide = Array.from(hiddenItems).some(item => item.classList.contains("hide"));

    if (!remainingHide) {
      this.el.classList.add('hide');
    }

    this.count();
  }

  count() {
    let hiddenItems = [];
    if(this.el.classList.contains('post-item__pagination--desktop')) {
      hiddenItems = document.querySelectorAll(".post-item--desktop.hide");
    } else if(this.el.classList.contains('post-item__pagination--mobile')){
      hiddenItems = document.querySelectorAll(".post-item--mobile.hide");
    }
    const countDiv = this.button.querySelector('.count');

    hiddenItems.length > 0 ? countDiv.innerHTML = '[' + hiddenItems.length + ']' : '';
  }
}

function initPaginatioNews() {
  const paginations = document.querySelectorAll(".post-item__pagination");

  paginations.forEach((btn) => {
    new PaginatioNews(btn);
  });
}

initPaginatioNews();




// Botón de compartir en RRSS
document.addEventListener("DOMContentLoaded", function () {
  const shareButton = document.querySelector(".post-rrss");
  const shareNav = shareButton?.closest(".post-content__share")?.querySelector("nav");

  if (shareButton && shareNav) {
    shareButton.addEventListener("click", function () {
      const isExpanded = shareNav.classList.toggle("visible");
      shareButton.setAttribute("aria-pressed", isExpanded ? "true" : "false");
    });
  }
});

